import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import { Resources } from '@app/resources';
import { BaseLoadComponent } from '@shared/components/classes/base-load.component';
import { Observable } from 'rxjs';
import { PaginatorModule } from '@primeng/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import {DatePipe, NgClass, NgIf} from '@angular/common';
import {NgxSkeletonLoaderComponent} from 'ngx-skeleton-loader';
import {PageTitleComponent} from '@shared/components/page-title/page-title.component';
import {FullNamePipe} from '@common/pipe/full-name.pipe';
import urlJoin from 'url-join';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ConfirmationDialogService } from '@shared/services/modal/confirm-modal.service';
import { SweetAlertService } from '@shared/services/sweet-alert.service';
import { Router } from '@angular/router';
import {ModalService} from '@shared/services/modal/modal.service';
import {ModalClose} from '@shared/services/modal/modal.enum';
import {RentersService} from '@modules/universal-billing/renters/renters.service';
import { ApiService } from '@shared/services/api.service';
import {
  ContractDetailsFormComponent
} from '@modules/universal-billing/property-management/contracts/contract-details/forms/contract-details-form/contract-details-form.component';
import { RentalContract } from '@modules/universal-billing/contract/contract.interface';
import {RenterNamePipe} from '@common/pipe/renter-name.pipe';
import {ApartmentsComponent} from '@modules/universal-billing/apartments/apartments.component';
import {PaymentsComponent} from '@modules/universal-billing/accounting/payments/payments.component';
import {ContractsComponent} from '@modules/universal-billing/renters/renters-details/contracts/contracts.component';
import { BalanceComponent } from '@modules/universal-billing/renters/renters-details/balance/balance.component';
import {DocumentsComponent} from '@modules/universal-billing/accounting/documents/documents.component';
import {
  InvoicesHistoryComponent
} from '@modules/universal-billing/invoices/tabs/invoices-history/invoices-history.component';

@Component({
  selector: 'renters-details',
  standalone: true,
  imports: [PaginatorModule, ReactiveFormsModule, NgClass, TranslatePipe, NgxSkeletonLoaderComponent, PageTitleComponent, FullNamePipe, NgIf, DatePipe, PaymentsComponent, ContractsComponent, RenterNamePipe, ApartmentsComponent, ContractsComponent, ContractsComponent, ContractsComponent, BalanceComponent, DocumentsComponent, InvoicesHistoryComponent],
  templateUrl: './renters-details.component.html',
  styleUrl: './renters-details.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class RentersDetailsComponent extends BaseLoadComponent<any> {
  @Input() id: number;

  activeTab: string = 'renters-apartments';
  activeServiceTab: string = 'rental-agreement';
  _http = inject(HttpClient);
  confirmModalService = inject(ConfirmationDialogService);
  sweetAlertService = inject(SweetAlertService);
  protected modalService = inject(ModalService);
  translate = inject(TranslateService);
  rentalAgreement:any;

  tabs = [
    { key: 'renters-apartments', label: 'RESIDENTIAL_UNUTS' },
    { key: 'services', label: 'PROPERTY.TAB.CONTRACTS_EKSPLUAT' },
    { key: 'payments', label: 'MENU.PAYMENTS' },
    { key: 'invoices', label: 'MENU.INVOICES' },
    { key: 'documents', label: 'DOCUMENTS' }
  ];

  constructor(private router: Router) {
    super();
  }

  public breadCrumbItems = [];

  protected translateService = inject(TranslateService);
  protected rentersService = inject(RentersService);

  getData(): Observable<any> {
    return this.rentersService.getOne(this.id);
  }
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }

  setActiveServiceTab(tab: string): void {
    this.activeServiceTab = tab;
  }

  onEdit() {
    this.modalService.open({
      component: this.rentersService.formComponent,
      title: this.translate.instant('EDIT_RENTERS'),
      componentOptions: {
        selectedRow: this.data(),
        isEdit: true,
        _defaultService: this.rentersService,
        modalType: 'user'
      },
      modalOptions: this.rentersService?.formModalOptions ?? {}
    }).then((res) => {
      if (res == ModalClose.SUCCESS) {
        this.loadData();
      }
    }).catch((err) => {})
  }
  api=inject(ApiService)


  contractEdit(){
    this.modalService.open({
      component: ContractDetailsFormComponent,
      title: this.translate.instant('EDIT'),
      componentOptions: {
       contract:this.rentalAgreement,
        afterSuccess: this.afterSuccess.bind(this)
      },
      modalOptions: {
        size: 'xl'
      }
    }).then((res) => {
      if (res == ModalClose.SUCCESS) {
        this.loadData();
      }
    }).catch((err) => {})
  }
  afterSuccess(response: RentalContract) {
    this.data.set(response);
  }

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'renters');
  }
  delete(id) {
    this.confirmModalService.open().then((res) => {
      if (res) {
        this._http.delete(urlJoin(this.getUrl(), String(id))).subscribe(
          () => {
            this.sweetAlertService.success('', 'TOAST.TOAST_DELETE').then(r => {
              this.router.navigate([Resources.Renters]);
            });
          },
          (error) => this.alertErrorMessage(error?.error?.message)
        )
      }
    })
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      {label: this.translateService.instant('COMPANIES.COMPANIES'), link: Resources.Renters},
      {label: this.id},
      {label: this.translateService.instant('COMPANIES.COMPANIESDETAILES'), active: true}
    ];
    super.ngOnInit();
  }
}
